// Knowledge Tracing — frontend constants
// Centralizes all KT tuning values used across popup, dashboard, and triggers.

// ---------------------------------------------------------------------------
// Popup timing
// ---------------------------------------------------------------------------
export const KT_POPUP_DELAY_MS = 3000;       // delay before showing popup after trigger event
export const KT_AUTO_DISMISS_MS = 45_000;    // auto-dismiss popup after 45 seconds
export const KT_FEEDBACK_MS = 1_500;         // show correct/incorrect feedback for 1.5s

// ---------------------------------------------------------------------------
// Mastery thresholds
// SOURCE OF TRUTH: backend/kt_constants.py — update there first, then here.
// Backend also exposes GET /api/kt/config for runtime access.
// ---------------------------------------------------------------------------
export const KT_THRESHOLD_STRUGGLING = 0.4;  // TIER_THRESHOLD_INTERMEDIATE
export const KT_THRESHOLD_PROFICIENT = 0.9;  // TIER_THRESHOLD_ADVANCED
